import React, { Fragment, useContext, useEffect, useState } from "react";
import { Transition, Menu } from "@headlessui/react";
import AuthContext from "../context/AuthContext";
import { Link } from "react-router-dom";
import OImage from "./reusable/OImage";
import { MdNotificationsActive, MdNotificationsNone } from "react-icons/md";
import { apiGet } from "utils/apiFetch";
import apiPath from "utils/apiPath";
import { useTranslation } from "react-i18next";

const TopNavBar = () => {
  const { logoutUser, user, handleSidebar, pageName, updatePageName } =
    useContext(AuthContext);
  const { t } = useTranslation();
  const [isNotification, setIsNotification] = useState(false);
  const getNotifications = async () => {
    const result = await apiGet(apiPath.getNotification);
    if (result?.status === 200) {
      setIsNotification(result?.data?.results?.isNotification);
    }
  };

  const handleLogout = () => {
    if (window.confirm("Are you sure to logout?")) {
      logoutUser();
    }
  };

  useEffect(() => {
    getNotifications();
  }, []);
  return (
    <div className="linHeader border-b py-4 px-4 md:px-8">
      <header className="bg-white items-center flex">
        <div className="mr-4 lg:mr-0 visible lg:invisible w-auto lg:w-0" onClick={() => handleSidebar()}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
            />
          </svg>
        </div>

        <div className="page_heading ">
          <h1 className="flex items-center text-lg text-slate-900 font-medium">
            {pageName}
          </h1>
        </div>
        <Menu
          as="div"
          className="relative inline-block text-left hover:text-LightBlue sidebar_dropdown ml-auto"
        >
          <div>
            <Menu.Button className="flex relative items-center w-full text-black active:text-LightBlue hover:bg-white hover:text-LightBlue group">
              <span>
                <div className="flex justify-end ">
                  <Link
                    to="/notification"
                    className="mr-4 relative "
                    onClick={()=>getNotifications()}
                  >
                    {isNotification ? (
                      <div className="flex">
                      <MdNotificationsActive className="w-8 h-8 relative" />
                      <span className="absolute top-[-5px] right-0 h-2 w-2 rounded-full bg-red-500"></span>
                      </div>
                    ) : (
                      <MdNotificationsNone className="w-8 h-8" />
                    )}
                  </Link>
                </div>
              </span>
              <div className="profile flex items-center ml-auto md:mr-10 mr-2">
                <figure className="inline-block overflow-hidden rounded-full">
                  <OImage
                    src={user?.profilePic}
                    fallbackUrl="/images/user.png"
                    className="w-[40px] h-[40px] inline"
                    alt=""
                  />
                </figure>
                <small className="block text-sm text-slate-900 ml-2 md:block hidden">
                  {user?.firstName} {user?.lastName}
                </small>
              </div>
            </Menu.Button>
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-10"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items className="absolute z-10 text-left min-w-[200px]  right-2 content divide-y divide-gray-100  bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
              <div className="">
                <Menu.Item onClick={() => updatePageName("Edit profile")}>
                  {({ active }) => (
                    <Link
                      to="/profile"
                      className={`${
                        active ? "bg-violet-500 text-white" : "text-gray-900"
                      } group flex w-full items-center  px-6 py-2 text-sm`}
                    >
                      Edit profile
                    </Link>
                  )}
                </Menu.Item>

                <Menu.Item onClick={() => updatePageName("Change password")}>
                  {({ active }) => (
                    <Link
                      to="/change-password"
                      className={`${
                        active ? "bg-violet-500 text-white" : "text-gray-900"
                      } group flex w-full items-center  px-6 py-2 text-sm`}
                    >
                      Change password
                    </Link>
                  )}
                </Menu.Item>
              </div>
              <div className="">
                <Menu.Item>
                  {({ active }) => (
                    <button
                      onClick={handleLogout}
                      className={`${
                        active ? "bg-violet-500 text-white" : "text-gray-900"
                      } group flex w-full items-center  px-6 py-2 text-sm`}
                    >
                      Logout
                    </button>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </Menu>

        {/* <a
                    href='#'
                    className='bg-LightBlue flex text-sm px-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue'
                >
                    <img src='./images/google-play.svg' className='pr-2' alt='' />
                    Download App
                </a> */}
      </header>
    </div>
  );
};

export default TopNavBar;
